import Content from "Types/Content";
import { useEffect } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import { Link, RouteProps } from "react-router-dom";
import "./builds.scss";
import { LoadingHome } from "Developers/EstebanCaccin/components/LoadingHome/LoadingHome";
import { useBuilds } from "./useBuilds";
import { useLoadingHome } from "../../Developers/EstebanCaccin/components/LoadingHome/useLoadingHome";

const Builds: React.FC<RouteProps> = () => {
  const { init, render, deleteBuilds } = useBuilds();
  const { loading, isLoadingHome } = useLoadingHome({ time: 6000 });
  useEffect(() => {
    loading();
    init();
    render();
  }, []);

  return (
    <Container className='builds text-center'>
      {isLoadingHome ? (
        <LoadingHome />
      ) : (
        <Row className='mh-100 vw-100'>
          <Col sm={6}>
            <h1>Builds</h1>
            <p>Haga clic para crear cubos.</p>
            <p>Shift + Click para eliminar cubos.</p>
            <p>Crombie Docs solo permite cubos en el tablero.</p>
          </Col>
          <Col sm={6} className='h-100 overflow-auto mt-5 p-1'>
            <p>
              ¿Te gustó mas la pantalla de carga?
              <br />
            </p>
            <p>
              <Button variant='primary' size='sm' onClick={loading}>
                Cargar nuevamente
              </Button>
            </p>
            <p>
              <Link to='/'>
                <Button variant='primary' size='sm' onClick={deleteBuilds}>
                  Regresar
                </Button>
              </Link>
            </p>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default new Content({
  Component: Builds,
  title: "Builds",
  route: "builds"
});
